import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Popup,
  //Button,
} from "semantic-ui-react";

const Services = () => {
  const [state, setState] = useState({ play: true, stop: false });

  const activePlay = () => {
    setState({ ...state, play: true, stop: false });
  };

  const activeStop = () => {
    setState({ ...state, play: false, stop: true });
  };

  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };

  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 700,
    // initialSlide: 0,
    arrows: false,
    responsive: [
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true
      //   }
      // },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const play = () => {
    sliderRef.slickPlay();
    activePlay();
  };
  const pause = () => {
    sliderRef.slickPause();
    activeStop();
  };
  //*************** */

  const renderPlayStopButton = () => {
    if (state.play) {
      return (
        <Popup
          content={"Stop"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={pause}>
              <img
                src="/stop.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
    if (state.stop) {
      return (
        <Popup
          content={"Play"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={play}>
              <img
                src="/play.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
  };

  //^^^^^^^^^^
  return (
    <section className="padding-gr-outer bgColor-gr ">
      <div className="inner-gr bgColor-gr">
        <div className="headtitl">
          <div className="line-height-gr font-36B color-CornflowerBlue px-20">
            Our Services Our Passion
          </div>
          <p
            style={{ margin: "auto", textAlign: "justify" }}
            className="font-18B px-20"
          >
            Whatever we do in our Company, we try to do it the best way
            possible. We make sure the customers are taken care of whatever they
            are looking for related to our scope of business.
          </p>

          <div className="devider"></div>
        </div>
        {/*  */}
        <div
          style={{ margin: "auto", maxWidth: "1140px" }}
          className="slider-container"
        >
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/sp.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">
                    SALE & PURCHASE
                  </div>
                  <p className="font-card-p">
                    Those days are gone when seller or buyer needs to run from
                    pillar to post in order to complete the process and
                    transaction. our dedicated team makes sure that every step
                    is handled professionally and transparently while our client
                    just sit back and relax.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/rent.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">
                    RENTALS AND LEASING
                  </div>
                  <p className="font-card-p">
                    Whether our client wants to rent a home or a place to work
                    from, our well experienced leasing team is always dedicated
                    to take care of all the work starting from finding them the
                    best option to completing the documentation & formalities
                    and handing over the keys.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/int.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">
                    CONSTRUCTION AND INTERIORS
                  </div>
                  <p className="font-card-p">
                    When it comes to building your dream home, we provide you
                    the best of designs and implementation. We have 130+ happy
                    clients for whom we have worked. Our work includes high
                    quality of raw materials, skilled workers and highly
                    qualified and mentally strong technical team. There are many
                    reasons why we are the best, one of the best reasons is that
                    our client’s are happy by our work.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img
                    className="img-border-bg"
                    src="/homeloan.png"
                    alt="why1 "
                  />
                </div>
                <div>
                  <div className="font-20B textAlign-center">
                    HOME LOANS AND LAP
                  </div>
                  <p className="font-card-p">
                    Attractive Home Loan Rates and offers have made buying a
                    home very easy. we have tie-up with almost all banks to take
                    care of your financial needs at best rate of interest and
                    terms with all documentation & process being completed from
                    your door step to make it a stress free ride.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/vastu.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">VASTU</div>
                  <p className="font-card-p">
                    Vaastu is a subtle way of bringing home harmony and
                    channelizing energy in and around you & your home. We
                    provide Vaastu consulting to make s home Vaastu - PERFECT.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/doc.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">
                    DOCUMENTATION / AGREEMENTS
                  </div>
                  <p className="font-card-p">
                    Documentation & agreement being the most important part of
                    any property transaction, and we give it through importance.
                    all documentation is taken care of Personally by our
                    Director to make sure we don't miss on any legal aspect
                    while moving towards the closure of our deals.
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            <div>
              <div className="card-service direction-c">
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <img className="img-border-bg" src="/nri.png" alt="why1 " />
                </div>
                <div>
                  <div className="font-20B textAlign-center">NRI CORNER</div>
                  <p className="font-card-p">
                    A person sitting overseas thinking of selling or buying have
                    been made easy. We can guide them of completing the entire
                    process flawlessly by advising at each step when its needed
                    and have completed more then 200+ transactions involving
                    NRIs. Whether its Taxation, documentation, Registration or
                    anything, we are THERE.
                  </p>
                </div>
              </div>
            </div>
          </Slider>

          <div style={{ textAlign: "center" }}>
            <Popup
              content={"Previous"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={previous}>
                  <img
                    src="/pre.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />

            {renderPlayStopButton()}
            <Popup
              content={"Next"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={next}>
                  <img
                    src="/next.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />

            {/* <button className="button" onClick={previous}>
          Previous
        </button>
        <button className="button" onClick={next}>
          Next
        </button> */}
          </div>
        </div>

        {/*  */}
      </div>
    </section>
  );
};

export default Services;
